import type { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  req = req.clone({
    headers: req.headers.set('Authorization', `Token ${environment.AUTH_TOKEN}`),
  });
  return next(req);
};
